import React from 'react'
import { graphql, Link } from 'gatsby'

import Layout from '../components/Layout/mainLayout'
import Seo from '../components/seo'

// images
import Logo from '../assets/images/Logo/Biome_Logo.webp'
import Welcome from '../assets/images/Cards/Welcome.webp'
import Mockup from '../assets/images/Cards/Mockup.png'
import S1_Animal from '../assets/images/Safari/S1-Animal.webp'
import S1_Biome from '../assets/images/Safari/S1-Biome.webp'
import S1_Item from '../assets/images/Safari/S1-Item.webp'

// videos
import HeroVideo from '../assets/videos/Hero.mp4'

// Fontawesome icons
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faGooglePlay } from '@fortawesome/fontawesome-free-brands'

const Index = ({ data }) => {
    return (
        <Layout>
            <Seo title="Home" />
            <main id="main">
                <section
                    id="hero"
                    className="h-[85vh] md:h-[90vh] xl:h-[95vh] relative"
                >
                    <video
                        className="absolute top-0 left-0 w-full h-full object-cover z-10 ease-in-out duration-500"
                        autoPlay
                        playsInline
                        muted
                        loop
                        src={HeroVideo}
                    ></video>
                    <div className="videoOverlay w-full h-full absolute top-0 left-0 z-20"></div>
                    <div className="w-full h-full flex flex-col justify-center items-center relative z-30 px-4">
                        <img
                            src={Logo}
                            alt="Biomecard Logo"
                            className="w-56 h-auto"
                            loading="lazy"
                        />
                        <h1
                            data-sal="slide-up"
                            data-sal-easing="ease"
                            data-sal-duration="700"
                            className="tracking-tight text-accentPrime text-4xl md:text-5xl xl:text-6xl text-center"
                        >
                            A NEW TRADING CARD GAME
                        </h1>
                        <h2
                            data-sal="slide-up"
                            data-sal-delay="300"
                            data-sal-easing="ease"
                            data-sal-duration="700"
                            className="pt-4 text-gray-50 text-xl md:text-2xl xl:text-3xl text-center"
                        >
                            THE WORLD’S MOST POWERFUL, FASTEST AND STRONGEST
                            ANIMALS
                        </h2>
                    </div>
                    <div className="w-full h-full absolute top-0 left-0 circle">
                        <div className="semicircle bottom"></div>
                        <div className="explore">
                            <a href="#WhyUs">
                                <div id="mouse-scroll">
                                    <div className="mouse">
                                        <div className="mouse-in"></div>
                                    </div>
                                    <div>
                                        <span className="down-arrow-1"></span>
                                        <span className="down-arrow-2"></span>
                                        <span className="down-arrow-3"></span>
                                    </div>
                                </div>
                            </a>
                        </div>
                    </div>
                </section>
                <section id="WhyUs" className="py-16 xl:pb-24">
                    <div className="grid grid-cols-1 lg:grid-cols-2 px-6 py-6 lg:py-16 relative overflow-hidden max-w-7xl mx-auto">
                        <div
                            data-sal="slide-right"
                            data-sal-delay="300"
                            data-sal-easing="ease"
                            data-sal-duration="1000"
                            className="w-auto flex items-center justify-center pb-16 xl:pb-0 "
                        >
                            <div className="block">
                                <h2 className="tracking-tight font-bold text-gray-50 text-5xl md:text-6xl text-center lg:text-left">
                                    <span>
                                        WELCOME TO
                                        <br />
                                    </span>
                                    <span className="text-accentPrime">
                                        BIOME
                                    </span>
                                </h2>
                                <p className="mt-3 text-base text-gray-300 sm:mt-5 sm:text-lg sm:max-w-2xl sm:mx-auto lg:mx-0 text-justify font-normal">
                                    A new trading card game that lets you
                                    reimagine the world we live in. <br />
                                    From the edges of the arctic tundra and
                                    desolate marine floor to the murky swamps
                                    and expansive metropolises beyond your own
                                    front door, and every inhabitant with it!
                                    <br />
                                    Learn about earths wildest, strangest, and
                                    rarest creatures as you collect, trade and
                                    battle your way to victory!
                                </p>
                            </div>
                        </div>
                        <div
                            className="xl:w-[100%] flex justify-center items-center flex-col xl:pb-0 logo relative "
                            data-sal="slide-left"
                            data-sal-delay="300"
                            data-sal-easing="ease"
                            data-sal-duration="1000"
                        >
                            <img
                                className="w-auto h-[350px] lg:h-[500px] mx-auto"
                                src={Welcome}
                                alt="Biomecards"
                                loading="lazy"
                            />
                        </div>
                    </div>
                    <div className="flex items-center justify-center max-w-3xl px-6 mx-auto pb-16 pt-8">
                        <video
                            width="100%"
                            height="100%"
                            controls
                            src={HeroVideo}
                        ></video>
                    </div>
                </section>
                <section className="relative">
                    <div className="skewedUpper"></div>
                </section>
                <section className="pt-4 pb-8 bg-black z-10 relative">
                    <div className="w-full relative flex flex-col">
                        <h2 className="tracking-tight font-bold text-gray-50 text-3xl md:text-4xl xl:text-5xl text-center pt-12">
                            CARD TYPES
                        </h2>
                        <div
                            id="hoverContainer"
                            className="px-6 pt-4 flex flex-col sm:flex-row max-w-4xl mx-auto overflow-hidden"
                        >
                            <Link
                                to="/en/Safari/S1/Animals"
                                className="item group relative z-30 sm:overflow-hidden"
                            >
                                <img
                                    className="relative"
                                    src={S1_Animal}
                                    alt="Animals"
                                    loading="lazy"
                                ></img>
                                <div className="imageButton_overlay absolute top-0 left-0 z-10"></div>
                                <div className="absolute top-0 sm:top-[400px] left-0 w-full h-full">
                                    <h2 className="block sm:hidden absolute -bottom-[15px] left-[5px] text-gray-50 text-[26px] font-bold origin-top-left -rotate-90 whitespace-nowrap z-20">
                                        S1{' '}
                                        <span className="text-accentPrime">
                                            ANIMALS
                                        </span>
                                    </h2>
                                    <h2 className="hidden sm:block absolute -top-[15px] left-[5px] text-gray-50 text-[26px] font-bold origin-top-left -rotate-90 whitespace-nowrap z-20">
                                        SEASON 1 {' - '}
                                        <span className="text-accentPrime">
                                            ANIMALS
                                        </span>
                                    </h2>
                                </div>
                                <div className="absolute top-[30px] left-[40%] ">
                                    <h2 className="absolute -top-[15px] left-[5px] bg-primary text-accentPrime rounded-sm px-2 py-1 text-[18px] font-semibold origin-top-left whitespace-nowrap z-20 opacity-0 group-hover:opacity-100 duration-500 ease-in-out">
                                        EXPLORE
                                    </h2>
                                </div>
                            </Link>
                            <Link
                                to="/en/Safari/S1/Biomes"
                                className="item group relative z-30 sm:overflow-hidden"
                            >
                                <img
                                    src={S1_Biome}
                                    alt="Biomes"
                                    loading="lazy"
                                ></img>
                                <div className="imageButton_overlay absolute top-0 left-0 z-10"></div>
                                <div className="absolute top-0 sm:top-[400px] left-0 w-full h-full">
                                    <h2 className="block sm:hidden absolute -bottom-[15px] left-[5px] text-gray-50 text-[26px] font-bold origin-top-left -rotate-90 whitespace-nowrap z-20">
                                        S1{' '}
                                        <span className="text-accentPrime">
                                            BIOMES
                                        </span>
                                    </h2>
                                    <h2 className="hidden sm:block absolute -top-[15px] left-[5px] text-gray-50 text-[26px] font-bold origin-top-left -rotate-90 whitespace-nowrap z-20">
                                        SEASON 1 {' - '}
                                        <span className="text-accentPrime">
                                            BIOMES
                                        </span>
                                    </h2>
                                </div>
                                <div className="absolute top-[30px] left-[40%] ">
                                    <h2 className="absolute -top-[15px] left-[5px] bg-primary text-accentPrime rounded-sm px-2 py-1 text-[18px] font-semibold origin-top-left whitespace-nowrap z-20 opacity-0 group-hover:opacity-100 duration-500 ease-in-out">
                                        EXPLORE
                                    </h2>
                                </div>
                            </Link>
                            <Link
                                to="/en/Safari/S1/Items"
                                className="item group relative z-30 sm:overflow-hidden"
                            >
                                <img
                                    src={S1_Item}
                                    alt="Item"
                                    loading="lazy"
                                ></img>
                                <div className="imageButton_overlay absolute top-0 left-0 z-10"></div>
                                <div className="absolute top-0 sm:top-[400px] left-0 w-full h-full">
                                    <h2 className="block sm:hidden absolute -bottom-[15px] left-[5px] text-gray-50 text-[26px] font-bold origin-top-left -rotate-90 whitespace-nowrap z-20">
                                        S1{' '}
                                        <span className="text-accentPrime">
                                            ITEMS
                                        </span>
                                    </h2>
                                    <h2 className="hidden sm:block absolute -top-[15px] left-[5px] text-gray-50 text-[26px] font-bold origin-top-left -rotate-90 whitespace-nowrap z-20">
                                        SEASON 1 {' - '}
                                        <span className="text-accentPrime">
                                            ITEMS
                                        </span>
                                    </h2>
                                </div>
                                <div className="absolute top-[30px] left-[40%]">
                                    <h2 className="absolute -top-[15px] left-[5px] bg-primary text-accentPrime rounded-sm px-2 py-1 text-[18px] font-semibold origin-top-left whitespace-nowrap z-20 opacity-0 group-hover:opacity-100 duration-500 ease-in-out">
                                        EXPLORE
                                    </h2>
                                </div>
                            </Link>
                        </div>
                    </div>
                </section>
                <section className="relative z-[5]">
                    <div className="skewedUnder z-[5] relative"></div>
                </section>
                <section
                    id="store"
                    className="w-full pt-40 pb-24 xl:pt-52 xl:pb-32 px-6"
                >
                    <div className="flex w-full items-center justify-center">
                        <h2 className="tracking-tight font-bold text-gray-50 text-4xl md:text-5xl xl:text-6xl text-center">
                            <span>WHERE CAN I BUY </span>
                            <span className="text-accentPrime">
                                BIOMECARDS?
                            </span>
                        </h2>
                    </div>
                    <div className="grid grid-cols-1 xl:grid-cols-2 pt-16 gap-x-6 gap-y-12 mx-auto">
                        <div className="flex flex-col justify-start items-center max-w-2xl w-full mx-auto">
                            <h3 className="tracking-tight font-bold text-accentPrime text-4xl md:text-5xl italic">
                                RETAIL STORE
                            </h3>
                            <iframe
                                title="Biomecard Shops"
                                className="pt-8"
                                src="https://www.google.com/maps/d/u/1/embed?mid=1T7itTknd4gE-Q7nxlFqsBgcfyzMW76Y&ehbc=2E312F&callback=Function.prototype"
                                width="100%"
                                height="480"
                            ></iframe>
                        </div>
                        <div className="flex flex-col justify-start items-center max-w-2xl w-full mx-auto">
                            <ul>
                                <li>
                                    <a className="animated-arrow">
                                        <span className="the-arrow -left">
                                            <span className="shaft"></span>
                                        </span>
                                        <span className="main">
                                            <h3 className="text tracking-tight font-bold text-accentPrime text-4xl md:text-5xl">
                                                ONLINE SHOP
                                            </h3>
                                            <span className="the-arrow -right">
                                                <span className="shaft"></span>
                                            </span>
                                        </span>
                                    </a>
                                </li>
                            </ul>
                            <div className="containerStore w-full py-12 xl:py-14">
                                <div className="featured-img">
                                    <div className="flex flex-col px-8 py-20 bg-secondary rounded-md border-2 border-primary">
                                        <h4 className="text-accentPrime text-2xl md:text-3xl font-semibold uppercase pb-6">
                                            DEAL OF THE DAY
                                        </h4>
                                        {data.strapiDealOfTheDay
                                            .Productname && (
                                            <h3 className="text-gray-50 text-3xl md:text-4xl font-bold tracking-tight pb-6">
                                                {
                                                    data.strapiDealOfTheDay
                                                        .Productname
                                                }
                                            </h3>
                                        )}
                                        {data.strapiDealOfTheDay.Link && (
                                            <div className="flex items-center justify-left">
                                                <a
                                                    className="btnSecondary uppercase font-bold"
                                                    href={
                                                        data.strapiDealOfTheDay
                                                            .Link
                                                    }
                                                >
                                                    Get it now
                                                </a>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                <section className="relative">
                    <div className="skewedUpper"></div>
                </section>
                <section id="app" className="pt-8 pb-12 bg-black">
                    <div className="grid grid-cols-1 lg:grid-cols-2 px-6 pt-8 lg:pt-16 pb-16 lg:pb-24 relative overflow-hidden max-w-7xl mx-auto">
                        <div
                            className="w-full mx-auto flex justify-center items-center flex-col xl:pb-0 logo relative order-last lg:order-first"
                            data-sal="slide-right"
                            data-sal-delay="300"
                            data-sal-easing="ease"
                            data-sal-duration="1000"
                        >
                            <img
                                className="floating w-auto h-[450px] lg:h-[650px]"
                                src={Mockup}
                                alt="Biomecard"
                                loading="lazy"
                            />
                        </div>
                        <div
                            data-sal="slide-left"
                            data-sal-delay="300"
                            data-sal-easing="ease"
                            data-sal-duration="1000"
                            className="w-auto flex items-center justify-center pb-16 xl:pb-0 px-2 md:px-0"
                        >
                            <div className="block">
                                <h2 className="tracking-tight font-bold text-gray-50 text-5xl md:text-6xl text-center lg:text-left">
                                    <span className="text-accentPrime">
                                        BIOMECARD{' '}
                                    </span>
                                    <span>APP</span>
                                </h2>
                                <p className="my-3 text-base text-gray-300 sm:my-5 sm:text-lg sm:max-w-xl sm:mx-auto lg:mx-0 text-justify font-normal">
                                    Lorem ipsum dolor sit, amet consectetur
                                    adipisicing elit. Ad doloremque
                                    exercitationem, porro.
                                </p>
                                <div className="flex items-center justify-center md:justify-start social-btns">
                                    <a
                                        className="app-btn blu flex vert"
                                        href="#"
                                    >
                                        <FontAwesomeIcon icon={faGooglePlay} />
                                        <p>
                                            Get it on <br />{' '}
                                            <span className="big-txt">
                                                Google Play
                                            </span>
                                        </p>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                <section className="relative">
                    <div className="skewedUnder"></div>
                </section>
            </main>
        </Layout>
    )
}

export const strapiDealOfTheDayQuery = graphql`
    {
        strapiDealOfTheDay {
            id
            Link
            Productname
        }
    }
`

export default Index
